import { Locale } from 'vant';
import zhCN from 'vant/lib/locale/lang/zh-CN';
import enUS from 'vant/lib/locale/lang/en-US';
import thTH from 'vant/lib/locale/lang/th-TH';
import viVN from 'vant/lib/locale/lang/vi-VN';

export const SUPPORTED_LANGUAGES = ['zh', 'en', 'pt', 'th', 'vi'];

export const LANGUAGE_OPTIONS = [
  { code: 'zh', label: '简体中文', short: '中文' },
  { code: 'en', label: 'English', short: 'EN' },
  { code: 'pt', label: 'Português', short: 'PT' },
  { code: 'th', label: 'ไทย', short: 'TH' },
  { code: 'vi', label: 'Tiếng Việt', short: 'VN' },
];

const VANT_LOCALES = {
  zh: ['zh-CN', zhCN],
  en: ['en-US', enUS],
  pt: ['en-US', enUS],
  th: ['th-TH', thTH],
  vi: ['vi-VN', viVN],
};

// 旧首页和游戏页一直读取 locale，因此迁移时优先采用它。
const USER_LANGUAGE_KEYS = ['locale', 'lang', 'language'];

export function normalizeLanguage(language, fallback = 'zh') {
  return SUPPORTED_LANGUAGES.includes(language) ? language : fallback;
}

export function getUserLanguage() {
  for (let index = 0; index < USER_LANGUAGE_KEYS.length; index += 1) {
    const key = USER_LANGUAGE_KEYS[index];
    const language = localStorage.getItem(key);
    if (SUPPORTED_LANGUAGES.includes(language)) {
      return language;
    }
  }

  return '';
}

export function saveUserLanguage(language) {
  const normalizedLanguage = normalizeLanguage(language);
  USER_LANGUAGE_KEYS.forEach(key => localStorage.setItem(key, normalizedLanguage));
  applyUiLocale(normalizedLanguage);
  return normalizedLanguage;
}

export function applyUiLocale(language) {
  const lang = normalizeLanguage(language);
  const pair = VANT_LOCALES[lang] || VANT_LOCALES.en;
  Locale.use(pair[0], pair[1]);
}

export function getLanguageLabel(language) {
  const item = LANGUAGE_OPTIONS.find(opt => opt.code === language);
  return item ? item.short : String(language || '').toUpperCase();
}

export function getCachedDefaultLanguage() {
  try {
    const appInfo = JSON.parse(localStorage.getItem('appInfo') || '{}');
    return normalizeLanguage(appInfo.default_language);
  } catch (error) {
    return 'zh';
  }
}



// WEBPACK FOOTER //
// ./src/utils/language.js